/** The public source repository; the code is AGPL-3.0. */
export const GITHUB_URL = "https://github.com/merlijntishauser/traumabomen";
export const LICENSE_URL = `${GITHUB_URL}/blob/main/LICENSE`;

/** The iOS companion on the App Store; Apple redirects to the visitor's own storefront. */
export const APP_STORE_URL = "https://apps.apple.com/app/id6788860690";
